<template>
  <v-container grid-list-xs>

    <!-- Sanckbar d'erreur -->
    <v-snackbar v-model="snackErreur" color="red">
      {{snackMessage}}
      <v-btn text color="black" @click.native="snackErreur = false">{{ $tr.dialogCommon.close }}</v-btn>
    </v-snackbar>

    <modifier-trajets-popup ref="popupModifierTrajets" @trajetsValides="trajetsValidesEventHandler"></modifier-trajets-popup>

    <v-card>
      <v-card-title primary-title>
        <h-group>
          <div>{{$tr.kpi.title}}&nbsp;</div>
          <div class="indice" style="color: #404040; text-decoration: none;">{{ $tr.kpi.st1 }}</div> <!--issus des algorithmes-->
          <img src="/fb-16.ico" class="mx-1 mt-1" alt="Logo Linaware">
          <div class="indice">{{ $tr.kpi.st2 }}<!--flybox de--><a href="https://www.linaware.eu" target="_blank" style="color: #4040F0;">Linaware</a></div>
        </h-group>
      </v-card-title>
      <v-card-text>

        <v-tabs v-model="onglet">
          <v-tab>{{ $tr.kpi.tab1 }}</v-tab> <!--Statistiques--> 
          <v-tab>{{ $tr.kpi.tab2 }}</v-tab> <!--Wagons avec avarie--> 
        </v-tabs>

        <v-tabs-items v-model="onglet">
          
          <!-- ---------- Statistiques -------------------------- -->
          <v-tab-item>
            <!-- Tableau des trajets sélectionnés et courbes associées -->
            <div style="display: flex; flex-direction: column; align-items: center; overflow: auto; height: calc(100vh - 64px - 224px) !important;">

              <!-- Boutons de sélection -->
              <h-group class="mb-3">
                <!-- Période sur mésure -->
                <div style="width: 150px"><v-text-field hide-details type="date" :label="$tr.dialogCommon.from" v-model="s1dateDebut"></v-text-field></div>
                <div style="width: 150px" class="ml-2"><v-text-field hide-details type="date" :label="$tr.dialogCommon.to" v-model="s1dateFin" @change="saisieDateFinChangeEvent"></v-text-field></div>

                <!-- Période par semaine -->
                <v-group class="ml-5">
                  <v-btn color="success" x-small @click="semaineEnCours" :loading="loading">{{ $tr.timeCommon.currentWeek }}</v-btn>
                  <h-group class="mt-1" style="justify-content: space-around;">
                    <v-btn color="success" x-small @click="semaineMoinsUn" :loading="loading">{{ $tr.timeCommon.weekMinus1 }}</v-btn>
                    <v-btn color="success" class="ml-1" x-small @click="semainePlusUn" :loading="loading">{{ $tr.timeCommon.weekPlus1 }}</v-btn>
                  </h-group>
                </v-group>

                <!-- Période par mois -->
                <v-group class="ml-5">
                  <v-btn color="success" x-small @click="moisEnCours" :loading="loading">{{ $tr.timeCommon.currentMonth }}</v-btn>
                  <h-group class="mt-1" style="justify-content: space-around;">
                    <v-btn color="success" x-small @click="moisMoinsUn" :loading="loading">{{ $tr.timeCommon.monthMinus1 }}</v-btn>
                    <v-btn color="success" class="ml-1" x-small @click="moisPlusUn" :loading="loading">{{ $tr.timeCommon.monthPlus1 }}</v-btn>
                  </h-group>
                </v-group>

                <!-- Période par année -->
                <v-group class="ml-5">
                  <v-btn color="success" hide-details x-small @click="anneeEnCours" :loading="loading">{{ $tr.timeCommon.currentYear }}</v-btn>
                  <h-group class="mt-1" style="justify-content: space-around;">
                    <v-btn color="success"  x-small @click="anneeMoinsUn" :loading="loading">{{ $tr.timeCommon.yearMinus1 }}</v-btn>
                    <v-btn color="success" class="ml-1"  x-small @click="anneePlusUn" :loading="loading">{{ $tr.timeCommon.yearPlus1 }}</v-btn>
                  </h-group>
                </v-group>

                <!-- Regrouper par trajet ou par mois -->
                <v-radio-group v-model="regroupement" class="ml-5">
                  <v-radio label="Par trajet" :value="0" @click="agregerResultatParGroupe(trains)"></v-radio>
                  <v-radio label="Par mois" :value="1" @click="agregerResultatParGroupe(trains)"></v-radio>
                </v-radio-group>

                <!-- Bouton de sélection des trajets -->
                <v-btn color="success" class="ml-5" @click="boutonOuvrirPopupModifierTrajets" :loading="loading">{{ $tr.kpi.routesSelection }}</v-btn>

                <!-- Bouton d'exportation -->
                <v-btn color="success" class="ml-5" @click="boutonExporter" :loading="loading">{{ $tr.kpi.exportKpi }}</v-btn>

                <!-- Bouton d'exportation traçabilité -->
                <v-btn color="orange" class="ml-5" @click="boutonExporterTracabilite" :loading="loading">{{ $tr.kpi.exportData }}</v-btn>

              </h-group>

              <!-- tableau de données des trajets sélectionnés -->
              <div>
                <div style="max-width: 800px; font-size: 12px;" v-if="regroupement == REGROUPEMENT_MOIS"> {{ $tr.kpi.routes }} : {{ trajetsSelectionnesToString(trajetsSelectionnes) }}</div>
                <table>
                  <thead>
                    <tr>
                      <th class="text-left">{{ regroupement == REGROUPEMENT_TRAJET ? $tr.kpi.routes : $tr.timeCommon.month }}</th>
                      <th class="text-center">{{ $tr.kpi.c1 }}</th><!-- Trains fermés -->
                      <th class="text-center">{{ $tr.kpi.c2 }}</th><!-- Trains couverts -->
                      <th class="text-center">{{ $tr.kpi.c3 }}</th><!-- Trains en cours -->
                      <th class="text-center">{{ $tr.kpi.c4 }}</th><!-- Trains annulés -->
                      <th class="text-center">{{ $tr.kpi.c5 }}</th><!-- Nb total de trains -->
                      <th class="text-center">{{ $tr.kpi.c6 }}</th><!-- % de trains annulés -->
                      <th class="text-center">{{ $tr.kpi.c7 }}</th><!-- Nb de wagons moyens -->
                      <th class="text-center">{{ $tr.kpi.c8 }}</th><!-- Objectif -->
                      <th class="text-center">{{ $tr.kpi.c9 }}</th><!-- Ratio -->
                      <th class="text-center">{{ $tr.kpi.c10 }}</th><!-- Nb de palettes moyens -->
                      <th class="text-center">{{ $tr.kpi.c11}}</th><!-- Poids moyens -->
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(groupe, indexGroupe) in groupes" :key="indexGroupe">
                      <td>{{ groupe.nom }}</td>
                      <td class="fermeok">{{ groupe.compteurs[3] }}</td>
                      <td class="couvert">{{ groupe.compteurs[1] }}</td>
                      <td class="ouvert">{{ groupe.compteurs[2] }}</td>
                      <td class="annule">{{ groupe.compteurs[4] }}</td>
                      <td >{{ groupe.nbTrainsReels }}</td>
                      <td >{{ (groupe.compteurs[4] + groupe.compteurs[3] > 0) ? (Math.round(100 * groupe.compteurs[4] / (groupe.compteurs[4] + groupe.compteurs[3]))) : '-' }} %</td>
                      <td>{{ groupe.nbWagonsMoyens != undefined ? groupe.nbWagonsMoyens.toFixed(1) : '-' }}</td>
                      <td>{{ regroupement == REGROUPEMENT_TRAJET ? getObjectif(groupe).toFixed(1) : '-' }}</td>
                      <td>{{ groupe.ratio != undefined ? groupe.ratio.toFixed(1) : '-' }} %</td>
                      <td>{{ groupe.nbPalettesMoyens != undefined ? groupe.nbPalettesMoyens.toFixed(0) : '-' }}</td>
                      <td>{{ groupe.poidsMoyens != undefined ? groupe.poidsMoyens.toFixed(0) : '-' }}</td>
                    </tr>
                    <tr>
                      <td>TOTAUX</td>
                      <td class="fermeok">{{ totaux.compteurs[3] }}</td>
                      <td class="couvert">{{ totaux.compteurs[1] }}</td>
                      <td class="ouvert">{{ totaux.compteurs[2] }}</td>
                      <td class="annule">{{ totaux.compteurs[4] }}</td>
                      <td >{{ totaux.nbTrainsReels }}</td>
                      <td >{{ (totaux.compteurs[4] + totaux.compteurs[3] > 0) ? (Math.round(100 * totaux.compteurs[4] / (totaux.compteurs[4] + totaux.compteurs[3]))) : '-' }} %</td>
                      <td>{{ totaux.nbWagonsMoyens != undefined ? totaux.nbWagonsMoyens.toFixed(1) : '-' }}</td>
                      <td></td>
                      <td>{{ ((totaux.ratio != undefined) && (totaux.ratio != 0))  ? totaux.ratio.toFixed(1) : '-' }} %</td>
                      <td>{{ totaux.nbPalettesMoyens != undefined ? totaux.nbPalettesMoyens.toFixed(0) : '-' }}</td>
                      <td>{{ totaux.poidsMoyens != undefined ? totaux.poidsMoyens.toFixed(0) : '-' }}</td>
                    </tr>
                  </tbody>
                </table>

              </div>

              <!-- Courbes -->
              <v-group class="ml-3">
                <template>
                  <v-tabs v-model="tab">
                    <v-tab>{{ $tr.kpi.gtab1 }}</v-tab><!-- En synthèse -->
                    <v-tab>{{ $tr.kpi.gtab2 }}</v-tab><!-- Annulations -->
                    <v-tab>{{ $tr.kpi.gtab3 }}</v-tab><!-- Liste des trajets -->
                  </v-tabs>
                </template>

                <v-tabs-items v-model="tab">
                  <!-- En synthèse -->
                  <v-tab-item :eager="true">
                      <!-- courbe -->
                      <div>
                        <canvas ref="chart1"  width="800" height="400"></canvas>
                      </div>
                  </v-tab-item>

                  <!-- Annulations -->
                  <v-tab-item :eager="true">
                    <v-switch :label="$tr.kpi.groupByCategory" v-model="annulationsParCategorie" @change="boutonRegrouperParCategorieClick"></v-switch>
                    <div style="width: 800px; height: 600px">
                      <canvas ref="chart2" ></canvas>          
                    </div>
                  </v-tab-item>

                  <!-- Liste des trajet -->
                  <v-tab-item>
                    <v-switch hide-details class="mt-0" :label="$tr.kpi.c4" v-model="trajetsVoirTrainsAnnules" @change="boutontrajetsVoirTrainsAnnulesClick"></v-switch>
                    <v-simple-table dense fixed-header height="500px" class="pa-4" style="width: 1000px;" >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left" >
                              Id 
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frId', true)">mdi-arrow-up</v-icon>
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frId', false)">mdi-arrow-down</v-icon>
                            </th>
                            <th class="text-left" >
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frDepartDateTheorique', true)">mdi-arrow-up</v-icon>
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frDepartDateTheorique', false)">mdi-arrow-down</v-icon>
                            </th>
                            <th class="text-left">
                              Flux
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frDepartLieu', true)">mdi-arrow-up</v-icon>
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frDepartLieu', false)">mdi-arrow-down</v-icon>
                            </th>
                            <th class="text-left">
                              Statut
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frStatut', true)">mdi-arrow-up</v-icon>
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frStatut', false)">mdi-arrow-down</v-icon>
                            </th>
                            <th class="text-left">
                              Wagons
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('count(wgId)', true)">mdi-arrow-up</v-icon>
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('count(wgId)', false)">mdi-arrow-down</v-icon>
                            </th>
                            <th class="text-left">
                              Motif
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frMotifAnnulation', true)">mdi-arrow-up</v-icon>
                              <v-icon x-small color="white" class="ml-1" @click="trierTrajets('frMotifAnnulation', false)">mdi-arrow-down</v-icon>
                            </th>
                          </tr>
                        </thead>
                        <tbody >
                          <tr v-for="flux in listeFluxFiltree" :key="flux.frId">
                            <td style="font-size: 10px;">{{ flux.frId }}</td>
                            <td>{{ computeDateFlux(flux.frDepartDateTheorique) }}</td>
                            <td>{{ flux.frDepartLieu }} - {{ flux.frArriveeLieu }}</td>
                            <td>
                              <h-group>
                              <div :class="getStatutColor(flux.frStatut)" style="width: 20px; height: 20px; border: 1px solid #808080 !important"></div>
                              <div class="ml-2">{{ getStatutText(flux.frStatut) }}</div>
                            </h-group>
                            </td>
                            <td>{{ flux.frNbWagons }}</td>
                            <td>{{ flux.frMotifAnnulation }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-group>
            </div>
            
          </v-tab-item>

          <!-- ---------- Wagons avec avarie -------------------------- -->
          <v-tab-item>
            <div style="display: flex; flex-direction: column; align-items: center; overflow: auto; height: calc(100vh - 64px - 224px) !important;">
              <h-group class="mb-3">
                <!-- Période par année -->
                <v-group class="ml-5">
                  <v-btn color="success" hide-details x-small @click="anneeEnCoursW" :loading="loading">{{ $tr.timeCommon.currentYear }}</v-btn>
                  <h-group class="mt-1" style="justify-content: space-around;">
                    <v-btn color="success"  x-small @click="anneeMoinsUnW" :loading="loading">{{ $tr.timeCommon.yearMinus1 }}</v-btn>
                    <v-btn color="success" class="ml-1"  x-small @click="anneePlusUnW" :loading="loading">{{ $tr.timeCommon.yearPlus1 }}</v-btn>
                  </h-group>
                </v-group>
                <v-btn color="success"  x-small @click="parAnneeW" class="ml-5" :loading="loading">{{ $tr.timeCommon.byYear }}</v-btn>
              </h-group>
              <!-- Tableau -->
              <div>
                <table>
                  <thead>
                    <tr>
                      <th class="text-left">{{ $tr.timeCommon.period }}</th>
                      <th class="text-center">{{ $tr.kpi.nbWagonWithAvarie }}</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(wav, indexwav) in wavListe" :key="indexwav">
                      <td>{{ wav.periode }}</td>
                      <td>{{ wav.nb }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>              
            </div>

          </v-tab-item>
        </v-tabs-items>

      </v-card-text>
    </v-card>
    
  </v-container>
</template>

<script>
import Chart from 'chart.js';
import ModifierTrajetsPopup from './ModifierTrajetsPopup.vue'
import moment from 'moment';

export default {
  components: { ModifierTrajetsPopup  },

  data() {
    return {
      tab: null,
      TAB_SYNTHESE:0,
      TAB_ANNULATION:1,
      TAB_LISTE:2,
      onglet: 0,
      listeFlux: [],
      listeFluxFiltree: [],
      loading: false,
      snackErreur: false,
      snackMessage: "",
      trajets:[],
      trajetsSelectionnes:[],
      annulations: {
        labels: [],
        nb: [],
        pct: []
      },
      chartData: {
        labels: [ 'January', 'February', 'March' ],
        datasets: [ { data: [40, 20, 12] } ]
      },
      chartOptions: {
        responsive: true
      },
      dateDebut: new Date(),
      dateFin: new Date(),
      s1dateDebut: "",
      s1dateFin: "",
      totaux : {
        nbTrainsReels: 0,
        compteurs: [0, 0, 0, 0, 0],
        nbWagons: 0,
        nbWagonsMoyens: 0,
        nbWagonsObjectifs: 0,
        nb: 0,
        ratio: 0
      },      
      annulationsParCategorie: true,
      groupes: [],
      trains: [],
      regroupement: 0,
      REGROUPEMENT_TRAJET: 0,
      REGROUPEMENT_MOIS: 1,
      trajetsVoirTrainsAnnules: false,
      wavListe: [],
      wavAnnee: new Date().getFullYear()
    }
  },

  created() {
    this.lireTrajets()
    this.anneeEnCoursW()
  },

  methods: {
    lireTrajets() {
      const url = "/api/frFeuilleRoutes/trajetsKpi?access_token=" + this.$user.id
      this.$axios.get(url, {headers: {'Cache-Control': 'no-cache',  'Pragma': 'no-cache', 'Expires': '0',}})
        .then(function(response) {
          const trajets = response.data
          for (var idxTrajet = 0; idxTrajet < trajets.length; idxTrajet++) {
              const trajet = trajets[idxTrajet]
              trajet.compteurs = [0, 0, 0, 0, 0]
              trajet.nbTrainsReels = 0
              trajet.nbWagons = 0
              trajet.nbWagonsMoyens = 0
              trajet.nb = 0
              trajet.ratio = 0
              trajet.selectionne = true
          }
          this.trajets = trajets
          this.moisEnCours()
        }.bind(this))
    },

    lire() {
      this.mettreAJourDates()
      const dateDebut = this.moment(this.dateDebut).format("YYYY-MM-DD")
      const dateFin = this.moment(this.dateFin).format("YYYY-MM-DD")
      var filtreTrajets = "";
      this.trajetsSelectionnes = this.trajets.filter(t => t.selectionne)
      this.trajetsSelectionnes.forEach(t => {
        if (filtreTrajets != "") {
          filtreTrajets += ";"
        }
        filtreTrajets += t.nom
      })
      const filter = "dateDebut=" + dateDebut + "&dateFin=" + dateFin + "&trajets=" + filtreTrajets
      var url = "/api/frFeuilleRoutes/nbWagonsParFlux?access_token=" + this.$user.id + "&" + filter;
      this.loading = true;
      this.$axios.get(url)
        .then(function (response) {
          for(var idx=0; idx < response.data.length; idx++) {
            if (response.data[idx].frMotifAnnulation == null) {
              response.data[idx].frMotifAnnulation = ""
            }
          }
          this.listeFlux = response.data;
          this.listeFluxFiltree = this.trajetsVoirTrainsAnnules ? this.listeFlux.filter(fr => fr.frStatut == 4) : this.listeFlux
          setTimeout(function() {
            this.trains = response.data
            this.agregerResultatParGroupe(this.trains)
          }.bind(this), 50)
          this.loading = false;
        }.bind(this))
        .catch(function(error) {
          this.loading = false;
          this.afficherErreur(error.message + " " + (error.response != undefined ? error.response.statusText : ''))
        }.bind(this))
    },

    lireWagonsAvecAvarie() {
      this.loading = true
      const url = this.wavParAnnee ?
        "https://www.wagonreport.com/api/Constats/nbWagonsAvecAvarieParAn?access_token=01LakXGR4Lo0UhEizTYrkPC4qpl8PCXI128978azaevlNTaeKgGJ4lSdHeazEP0301zIVKi"
        :
        "https://www.wagonreport.com/api/Constats/nbWagonsAvecAvarieParMois?annee=" + this.wavAnnee + "&access_token=01LakXGR4Lo0UhEizTYrkPC4qpl8PCXI128978azaevlNTaeKgGJ4lSdHeazEP0301zIVKi"
      this.$axios.get(url, {headers: {'Cache-Control': 'no-cache',  'Pragma': 'no-cache', 'Expires': '0',}})
        .then(function(response) {
          this.wavListe = response.data
          this.loading = false
        }.bind(this))
        .catch(function(error) {
          console.log(error)
          this.loading = false
        }.bind(this))
    },

    afficherErreur(message) {
      this.snackMessage = message;
      this.snackErreur = true
      this.loading = false;
    },

    getObjectifDate(trajet, date) {
      if ((trajet == undefined) || (date == undefined)) {
        return 0
      }
      const d = new Date(date)
      if ((trajet.objectifsWagons == undefined) || (d == undefined)) {
        return 0
      }
      var objectif = trajet.objectifsWagons.find(o => date >= o.date)
      if (objectif == undefined) {
        return 0
      }
      return objectif.objectif

    },

    genererGroupesMois(trains)
    {
      moment.locale(this.$user.lang)
      trains.sort((a, b) =>  a.frDepartDateTheorique < b.frDepartDateTheorique ? -1 : (a.frDepartDateTheorique > b.frDepartDateTheorique ? 1 : 0))
      const groupes = []
      trains.forEach(train => {
        const anneeMois = train.frDepartDateTheorique.substr(0, 7)
        const groupe = groupes.find(g => g.anneeMois == anneeMois)
        if (groupe == undefined) {
          groupes.push({
            nom: moment(train.frDepartDateTheorique).format("MMMM YYYY"),
            anneeMois: anneeMois
          })
        }
      })
      return groupes
    },

    agregerResultatParGroupe(trains) {
      const parTrajet = this.regroupement == this.REGROUPEMENT_TRAJET
      // Préparation des totaux de tous les groupes
      var totaux = {
        nbTrainsReels: 0,
        compteurs: [0, 0, 0, 0, 0],
        nbWagons: 0,
        nbWagonsMoyens: 0,
        nbWagonsObjectifs: 0,
        nbPalettes: 0,
        nbPalettesMoyens: 0,
        poids: 0,
        poidsMoyens: 0,
        nb: 0,
        ratio: 0
      }

      // Création des groupes
      const groupes = parTrajet ? this.trajetsSelectionnes : this.genererGroupesMois(trains)
      // Itération groupe par groupe
      for (var idxGroupe = 0; idxGroupe < groupes.length; idxGroupe++) {
        const groupe = groupes[idxGroupe]
        // Initialisation des totaux du groupe
        groupe.nbTrainsReels = 0
        groupe.compteurs = [0, 0, 0, 0, 0]
        groupe.nbWagons = 0
        groupe.nbWagonsMoyens = 0
        groupe.nbWagonsObjectifs = 0
        groupe.nbPalettes = 0
        groupe.nbPalettesMoyens = 0
        groupe.poids = 0
        groupe.poidsMoyens = 0
        groupe.nb = 0
        groupe.ratio = 0
        
        // Liste des trains correspondant au groupe
        const trainsGroupe = parTrajet ? trains.filter(t => (t.frDepartLieu + "-" + t.frArriveeLieu) == groupe.nom) : trains.filter(t => t.frDepartDateTheorique.substr(0, 7) == groupe.anneeMois)
        groupe.nb = trainsGroupe.length
        trainsGroupe.forEach(train => {
          groupe.nbTrainsReels += train.frStatut != this.$FLUX_STATUT_PREVISIONNEL ?  1 : 0
          const nbWagonsTrain = ((train.frStatut == this.$FLUX_STATUT_OUVERT) || (train.frStatut == this.$FLUX_STATUT_FERME)) ? train.frNbWagons : 0
          groupe.nbWagons += nbWagonsTrain // Nb réel de wagons dans le train (sauf si annulé)
          const nbPalettesTrain = ((train.frStatut == this.$FLUX_STATUT_OUVERT) || (train.frStatut == this.$FLUX_STATUT_FERME)) ? train.frNbPalettes : 0
          groupe.nbPalettes += nbPalettesTrain // Nb réel de palettes dans le train (sauf si annulé)
          const poidsTrain = ((train.frStatut == this.$FLUX_STATUT_OUVERT) || (train.frStatut == this.$FLUX_STATUT_FERME)) ? train.frPoids : 0
          groupe.poids += poidsTrain // Poids dans le train (sauf si annulé)

          const trajet = parTrajet ? groupe : this.trajetsSelectionnes.find(t2 => t2.nom == (train.frDepartLieu + "-" + train.frArriveeLieu))
          groupe.nbWagonsObjectifs += this.getObjectifDate(trajet, train.frDepartDateTheorique)
        });
        groupe.ratio = groupe.nbWagonsObjectifs > 0 ? 100 * groupe.nbWagons / groupe.nbWagonsObjectifs : 0
        groupe.nbWagonsMoyens = groupe.nbTrainsReels > 0 ? groupe.nbWagons / groupe.nbTrainsReels : 0
        groupe.nbPalettesMoyens = groupe.nbTrainsReels > 0 ? groupe.nbPalettes / groupe.nbTrainsReels : 0
        groupe.poidsMoyens = groupe.nbTrainsReels > 0 ? groupe.poids / groupe.nbTrainsReels : 0
        for(var statut = 0; statut <= 4; statut++ ) {
          const nb = trainsGroupe.filter(t => t.frStatut == statut).length
          groupe.compteurs[statut] += nb
          totaux.compteurs[statut] += nb
        }

        totaux.nbTrainsReels += groupe.nbTrainsReels
        totaux.nbWagons += groupe.nbWagons
        totaux.nbPalettes += groupe.nbPalettes
        totaux.poids += groupe.poids
        //totaux.nbWagonsMoyens += groupe.nbWagonsMoyens
        totaux.nbTrainsReenbWagonsObjectifsls += groupe.nbWagonsObjectifs
        totaux.nb += groupe.nb
      }
      totaux.nbWagonsMoyens = totaux.nbTrainsReels > 0 ? totaux.nbWagons / totaux.nbTrainsReels : 0
      totaux.nbPalettesMoyens = totaux.nbTrainsReels > 0 ? totaux.nbPalettes / totaux.nbTrainsReels : 0
      totaux.poidsMoyens = totaux.nbTrainsReels > 0 ? totaux.poids / totaux.nbTrainsReels : 0

      this.totaux = totaux
      const annulations = {labels: [], nb: [], pct: []}
      const nbAnnulations = trains.filter(t => t.frStatut == 4).length
      const annulationsParCategorie = this.annulationsParCategorie
      trains.filter(t => t.frStatut == 4).forEach(d => {
        var motif = d.frMotifAnnulation.trim()
        if ((annulationsParCategorie) && (d.frMotifAnnulation.indexOf("-") > 0))
          motif = d.frMotifAnnulation.split("-")[0].trim()
        console.log("*" + d.frMotifAnnulation + "**" + motif + "***")
        var idx = annulations.labels.indexOf(motif)
        if (idx == -1) {
          const c0 = annulations.labels.find(l => l.toUpperCase() > motif.toUpperCase())
          idx = annulations.labels.indexOf(c0) != -1 ? annulations.labels.indexOf(c0) : annulations.labels.length
          annulations.labels.splice(idx, 0, motif)
          annulations.nb.splice(idx, 0, 1)
          annulations.pct.splice(idx, 0, (Math.round(100 / nbAnnulations)))
        }
        else {
          annulations.nb[idx]++
          annulations.pct[idx] = Math.round(100 * annulations.nb[idx] / nbAnnulations)
        }
      });
      if (annulations.labels.length == 0) {
        annulations.labels.push('-')
        annulations.nb.push('0')
        annulations.pct.push('0')
      }
      //annulations.labels.sort(function(a, b) { })
      //annulations.nb.forEach(nb => annulatiobs a.pct = 100 * a.nb / annulations.length)
      this.annulations = annulations
      console.log(this.annulations)

      this.groupes = groupes

      // Générer les données pour les graphiques
      this.genererGraphiques1() 
      this.genererGraphiques2() 
    },

    agregerResultat__________(trains) {
      // Itération trajet / trajet
      
      var totaux = {
        nbTrainsReels: 0,
        compteurs: [0, 0, 0, 0, 0],
        nbWagons: 0,
        nbWagonsMoyens: 0,
        nbWagonsObjectifs: 0,
        nbPalettes: 0,
        nbPalettesMoyens: 0,
        poids: 0,
        poidsMoyens: 0,
        nb: 0,
        ratio: 0
      }
      for (var idxTrajet = 0; idxTrajet < this.trajetsSelectionnes.length; idxTrajet++) {
        const trajet = this.trajetsSelectionnes[idxTrajet]
        trajet.nbTrainsReels = 0
        trajet.compteurs = [0, 0, 0, 0, 0]
        trajet.nbWagons = 0
        trajet.nbWagonsMoyens = 0
        trajet.nbWagonsObjectifs = 0
        trajet.nbPalettes = 0
        trajet.poids = 0
        trajet.nb = 0
        trajet.ratio = 0
        
        // Liste des trains du trajet sur la période demandée
        const trainsTrajet = trains.filter(t => ((t.frDepartLieu + "-" + t.frArriveeLieu) == trajet.nom))
        trajet.nb = trainsTrajet.length
        trainsTrajet.forEach(t => {
          trajet.nbTrainsReels += 1
          const nbWagonsTrain = ((t.frStatut == this.$FLUX_STATUT_OUVERT) || (t.frStatut == this.$FLUX_STATUT_FERME)) ? t.frNbWagons : 0
          trajet.nbWagons += nbWagonsTrain // Nb réel de wagons dans le train (sauf si annulé)
          trajet.nbWagonsObjectifs += this.getObjectifDate(trajet, t.frDepartDateTheorique)
          const nbPalettesTrain = ((t.frStatut == this.$FLUX_STATUT_OUVERT) || (t.frStatut == this.$FLUX_STATUT_FERME)) ? t.frNbPalettes : 0
          trajet.nbPalettes += nbPalettesTrain // Nb réel de palettes dans le train (sauf si annulé)
          const poidsTrain = ((t.frStatut == this.$FLUX_STATUT_OUVERT) || (t.frStatut == this.$FLUX_STATUT_FERME)) ? t.frPoids : 0
          trajet.poids += poidsTrain // Poids réel dans le train (sauf si annulé)
        });
        trajet.ratio = trajet.nbWagonsObjectifs > 0 ? 100 * trajet.nbWagons / trajet.nbWagonsObjectifs : 0
        trajet.nbWagonsMoyens = trajet.nbTrainsReels > 0 ? trajet.nbWagons / trajet.nbTrainsReels : 0
        trajet.nbPalettesMoyens = trajet.nbTrainsReels > 0 ? trajet.nbPalettes / trajet.nbTrainsReels : 0
        trajet.poidsMoyens = trajet.nbTrainsReels > 0 ? trajet.nbPalettes / trajet.poids : 0
        for(var statut = 0; statut <= 4; statut++ ) {
          const nb = trainsTrajet.filter(t => t.frStatut == statut).length
          trajet.compteurs[statut] += nb
          totaux.compteurs[statut] += nb
        }

        totaux.nbTrainsReels += trajet.nbTrainsReels
        totaux.nbWagons += trajet.nbWagons
        //totaux.nbWagonsMoyens += trajet.nbWagonsMoyens
        totaux.nbPalettes += trajet.nbPalettes
        totaux.poids += trajet.poids
        totaux.nbTrainsReenbWagonsObjectifsls += trajet.nbWagonsObjectifs
        totaux.nb += trajet.nb
      }
      totaux.nbWagonsMoyens = totaux.nbTrainsReels > 0 ? totaux.nbWagons / totaux.nbTrainsReels : 0
      totaux.nbPalettesMoyens = totaux.nbTrainsReels > 0 ? totaux.nbPalettes / totaux.nbTrainsReels : 0
      totaux.poidsMoyens = totaux.nbTrainsReels > 0 ? totaux.poids / totaux.nbTrainsReels : 0

      this.totaux = totaux
      const annulations = {labels: [], nb: [], pct: []}
      const nbAnnulations = trains.filter(t => t.frStatut == 4).length
      const annulationsParCategorie = this.annulationsParCategorie
      trains.filter(t => t.frStatut == 4).forEach(d => {
        var motif = d.frMotifAnnulation.trim()
        if ((annulationsParCategorie) && (d.frMotifAnnulation.indexOf("-") > 0))
          motif = d.frMotifAnnulation.split("-")[0].trim()
        console.log("*" + d.frMotifAnnulation + "**" + motif + "***")
        var idx = annulations.labels.indexOf(motif)
        if (idx == -1) {
          const c0 = annulations.labels.find(l => l.toUpperCase() > motif.toUpperCase())
          idx = annulations.labels.indexOf(c0) != -1 ? annulations.labels.indexOf(c0) : annulations.labels.length
          annulations.labels.splice(idx, 0, motif)
          annulations.nb.splice(idx, 0, 1)
          annulations.pct.splice(idx, 0, (Math.round(100 / nbAnnulations)))
        }
        else {
          annulations.nb[idx]++
          annulations.pct[idx] = Math.round(100 * annulations.nb[idx] / nbAnnulations)
        }
      });
      if (annulations.labels.length == 0) {
        annulations.labels.push('-')
        annulations.nb.push('0')
        annulations.pct.push('0')
      }
      //annulations.labels.sort(function(a, b) { })
      //annulations.nb.forEach(nb => annulatiobs a.pct = 100 * a.nb / annulations.length)
      this.annulations = annulations
      console.log(this.annulations)

      // Générer les données pour les graphiques
      //this.genererGraphiques1() 
      //this.genererGraphiques2() 
    },

    genererGraphiques1()
    {
      const labels = []
      const data1 = []
      const data2 = []
       for (var idxGroupe = 0; idxGroupe < this.groupes.length; idxGroupe++) {
        const groupe = this.groupes[idxGroupe]
        labels.push(groupe.nom)
        data1.push(groupe.nbWagonsMoyens)
        data2.push(this.getObjectif(groupe))
      }
      if (this.chart1 == null) {
          this.chart1 = new Chart(this.$refs.chart1, {
          type: 'line',
          data: {
            labels: labels,
            datasets: [
              {
                label: this.$tr.kpi.c8, // Objectif
                data: data2,
                type: 'line',
                borderWidth: 1,
                borderColor: '#FF8000',
                backgroundColor: '#FFFFFF',
                fill: false
              },
              {
                type:'bar',
                label: this.$tr.kpi.c7, // Nb wagons moyens
                data: data1,
                borderWidth: 1,
                backgroundColor: '#9BD0F5'
              },
            ]
          },
          options: {
            scales: {
              yAxes: [
              {
                id: 'nb',
                type: 'linear',
                position: 'left',
                ticks: {beginAtZero: true}
              }
            ]}
          }
        });
      }
      else {
        this.chart1.data.labels = labels
        this.chart1.data.datasets[0].data = data2
        this.chart1.data.datasets[1].data = data1
        this.chart1.update();
      }
    },

    genererGraphiques2() {
      if (this.chart2 == undefined) {
        this.chart2 = new Chart(this.$refs.chart2, {
          type: 'bar',
          data: {
            labels: this.annulations.labels,
            datasets: [
              {
                label: this.$tr.kpi.d1, // Nombre d'annulations
                data: this.annulations.nb,
                type: 'bar',
                borderWidth: 1,
                borderColor: 'red',
                backgroundColor: 'red',
                fill: false,
                yAxisID: 'nb',
                order: 1
              },
              {
                label: this.$tr.kpi.d2, // % du total
                data: this.annulations.pct,
                type: 'line',
                borderWidth: 1,
                borderColor: 'orange',
                backgroundColor: 'orange',
                fill: false,
                yAxisID: 'pct',
                order: 0
              },
            ]
          },
          options: {
            scales: {
              yAxes: [
              {
                id: 'nb',
                type: 'linear',
                position: 'left',
                ticks: {beginAtZero: true}
              },
              {
                id: 'pct',
                type: 'linear',
                display: true,
                position: 'right',
                ticks: {
                  min: 0,
                  max: 100,
                  beginAtZero: true
                },
              }
            ]},
          }
        });      
      }
      else {
        this.chart2.data.labels = this.annulations.labels
        this.chart2.data.datasets[0].data = this.annulations.nb
        this.chart2.data.datasets[1].data = this.annulations.pct
        this.chart2.update()
      }
    },

    mettreAJourDates() {
      this.s1dateDebut = moment(this.dateDebut).format("YYYY-MM-DD")
      this.s1dateFin = moment(this.dateFin).format("YYYY-MM-DD")
    },

    semaineEnCours() {
      const lundi = new Date()
      lundi.setDate(lundi.getDate() - (lundi.getDay() + 6) % 7);
      this.dateDebut = lundi
      this.dateFin = new Date().setDate(lundi.getDate() + 7)
      this.lire()
    },

    semaineMoinsUn() {
      this.dateDebut = this.moment(this.dateDebut).subtract(1, 'weeks')
      this.dateFin = this.moment(this.dateFin).subtract(1, 'weeks')
      this.lire()
    },

    semainePlusUn() {
      this.dateDebut = this.moment(this.dateDebut).add(1, 'weeks')
      this.dateFin = this.moment(this.dateFin).add(1, 'weeks')
      this.lire()
    },


    moisEnCours() {
      const now = new Date()
      const d0 = 1
      const m0 = now.getMonth()
      const y0 = now.getFullYear()
      const d1 = 1
      const m1 = m0 == 11 ? 0 : m0 + 1
      const y1 = m0 == 11 ? y0 + 1 : y0
      this.dateDebut = new Date(y0, m0, d0)
      this.dateFin = new Date(y1, m1, d1)
      this.lire()
    },


    moisMoinsUn() {
      this.dateDebut = this.moment(this.dateDebut).subtract(1, 'months')
      this.dateFin = this.moment(this.dateFin).subtract(1, 'months')
      this.lire()
    },

    moisPlusUn() {
      this.dateDebut = this.moment(this.dateDebut).add(1, 'months')
      this.dateFin = this.moment(this.dateFin).add(1, 'months')
      this.lire()
    },

    anneeEnCours() {
      const now = new Date()
      const d0 = 1
      const m0 = 0
      const y0 = now.getFullYear()
      const d1 = 1
      const m1 = 0
      const y1 = y0 + 1
      this.dateDebut = new Date(y0, m0, d0)
      this.dateFin = new Date(y1, m1, d1)
      this.lire()
    },

    anneePlusUn() {
      this.dateDebut = this.moment(this.dateDebut).add(1, 'years')
      this.dateFin = this.moment(this.dateFin).add(1, 'years')
      this.lire()
    },

    anneeMoinsUn() {
      this.dateDebut = this.moment(this.dateDebut).subtract(1, 'years')
      this.dateFin = this.moment(this.dateFin).subtract(1, 'years')
      this.lire()
    },

    anneeEnCoursW() {
      this.wavParAnnee = false
      this.wavAnnee = new Date().getFullYear()
      this.lireWagonsAvecAvarie()
    },

    anneePlusUnW() {
      this.wavParAnnee = false
      this.wavAnnee++
      this.lireWagonsAvecAvarie()
    },

    anneeMoinsUnW() {
      this.wavParAnnee = false
      this.wavAnnee--
      this.lireWagonsAvecAvarie()
    },

    parAnneeW() {
      this.wavParAnnee = true
      this.lireWagonsAvecAvarie()
    },

    saisieDateFinChangeEvent() {
      this.dateDebut = new Date(this.s1dateDebut)
      this.dateFin = new Date(this.s1dateFin)
      this.lire()
    },

    /**
     * Couleur du cadre de la feuille de route = f(statut)
     * @param {Number} frStatut 
     */
     getStatutColor(frStatut) {
      //console.log(fr)
      switch(frStatut) {
        case 0: return "white"              // Prévisionnel
        case 1: return 'blue lighten-3'     // Couvert
        case 2: return 'yellow lighten-3'   // Ouvert
        case 3: return 'green lighten-3'    // Fermé ok
        case 4: return 'red'                // Annulé
      }
      return 'orange'
    },

    computeDateFlux(date) {
      moment.locale("fr")
      return moment(date).format("Do MMMM yyyy")
    },

    /**
     * Couleur du cadre de la feuille de route = f(statut)
     * @param {Number} frStatut 
     */
     getStatutText(frStatut) {
      //console.log(fr)
      switch(frStatut) {
        case 0: return this.$tr.kpi.s1     // Prévisionnel
        case 1: return this.$tr.kpi.s2     // Couvert
        case 2: return this.$tr.kpi.s3     // Ouvert
        case 3: return this.$tr.kpi.s4     // Fermé ok
        case 4: return this.$tr.kpi.s5     // Annulé
      }
      return '-'
    },

    boutonOuvrirPopupModifierTrajets() {
      this.$refs.popupModifierTrajets.open(this.trajets)
    },

    trajetsValidesEventHandler(trajets) {
      console.log(trajets)
      this.trajets = trajets
      const url = "/api/frFeuilleRoutes/trajetsKpi?access_token=" + this.$user.id
      this.$axios.post(url, this.trajets)
      this.lire()
    },

    getObjectif(trajet) {
      if (trajet == undefined) {
        return ""
      }
      if (trajet.objectifsWagons == undefined) {
        return ""
      }
      if ((trajet.objectifsWagons.length == undefined) || (trajet.objectifsWagons.length == 0)) {
        return ""
      }

      const now = new Date()
      var idx = 0 
      var objectif = 0
      while (idx < trajet.objectifsWagons.length) {
        const d = new Date(trajet.objectifsWagons[idx].date)
        if (now >= d) {
          objectif = trajet.objectifsWagons[idx].objectif
        }
        idx++
      }
      return objectif
    },

    trajetsSelectionnesToString(trajetsSelectionnes)
    {
      var trajets = ""
      trajetsSelectionnes.forEach(trajet => {
        if (trajets != "") {
          trajets += " "
        }
        trajets += trajet.nom
      });
      return trajets
    },

    trierTrajets(cle, asc)
    {
      if (asc) {
        this.listeFlux.sort((a, b) => a[cle] < b[cle] ? -1 : (a[cle] > b[cle] ? 1 : 0))
      }
      else {
        this.listeFlux.sort((a, b) => a[cle] < b[cle] ? 1 : (a[cle] > b[cle] ? -1 : 0))
      }
    },

    boutonRegrouperParCategorieClick()
    {
      //this.lire();
      this.agregerResultatParGroupe(this.trains)
    },

    boutontrajetsVoirTrainsAnnulesClick() {
      this.listeFluxFiltree = this.trajetsVoirTrainsAnnules ? this.listeFlux.filter(fr => fr.frStatut == 4) : this.listeFlux
    },

    boutonExporterTracabilite() {
      this.loading = true
      const url = "/api/frFeuilleRoutes/tracabiliteFeuillesDeRoute?access_token=" + this.$user.id
      this.dateDebut = new Date(this.s1dateDebut)
      this.dateFin = new Date(this.s1dateFin)

      const dateDebut = this.moment(this.dateDebut).format("YYYY-MM-DD")
      const dateFin = this.moment(this.dateFin).format("YYYY-MM-DD")
      this.$axios({
        url: url,
        method: 'POST',
        responseType: 'blob',
        data: {dateDebut: dateDebut, dateFin: dateFin}
      })
        .then(function(response) {
          // create file link in browser's memory
          const href = URL.createObjectURL(response.data);
          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          const nomFichier = response.headers["content-disposition"].split("filename=")[1]
          link.setAttribute('download', nomFichier); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          this.loading = false
        }.bind(this))
        .catch(function(error) {
          this.loading = false;
          this.afficherErreur(error.message + " " + (error.response != undefined ? error.response.statusText : ''))
        }.bind(this))      
    },

    boutonExporter() {
      this.loading = true
      this.dateDebut = new Date(this.s1dateDebut)
      this.dateFin = new Date(this.s1dateFin)

      const url = "/api/frFeuilleRoutes/exporterTrajetsKpi?access_token=" + this.$user.id
      const dateDebut = this.moment(this.dateDebut).format("DD-MM-YYYY")
      const dateFin = this.moment(this.dateFin).format("DD-MM-YYYY")
      const tableau = []
      this.groupes.forEach(function(groupe) {
        tableau.push([
          groupe.nom,          //                 [0]                   
          groupe.compteurs[0], // prévisionnel    [1]
          groupe.compteurs[1], // couvert         [2]
          groupe.compteurs[2], // ouvert          [3]
          groupe.compteurs[3], // fermé           [4]
          groupe.compteurs[4], // annulé          [5]
          groupe.nbTrainsReels, //                [6]
          (groupe.compteurs[4] + groupe.compteurs[3] > 0) ? groupe.compteurs[4] / (groupe.compteurs[4] + groupe.compteurs[3]) : 0, // [7]
          groupe.nbWagonsMoyens != undefined ? groupe.nbWagonsMoyens : 0, // [8]
          this.regroupement == this.REGROUPEMENT_TRAJET ? this.getObjectif(groupe) : 0, // [9]
          groupe.ratio != undefined ? groupe.ratio / 100 : 0, // [10]
          groupe.nbPalettesMoyens, // [11]
          groupe.poidsMoyens       // [12]
        ])
      }.bind(this))
      this.$axios({
        url: url,
        method: 'POST',
        responseType: 'blob',
        data: {tableau: tableau, dateDebut: dateDebut, dateFin: dateFin, annulations: this.annulations, listeFlux: this.listeFluxFiltree}
      })
      //this.$axios.post(url, {tableau: tableau, dateDebut: dateDebut, dateFin: dateFin, annulations: this.annulations})
        .then(function(response) {
          // create file link in browser's memory
          const href = URL.createObjectURL(response.data);
          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          const nomFichier = response.headers["content-disposition"].split("filename=")[1]
          link.setAttribute('download', nomFichier); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          this.loading = false

        }.bind(this))
        .catch(function(error) {
          this.loading = false;
          this.afficherErreur(error.message + " " + (error.response != undefined ? error.response.statusText : ''))
        }.bind(this))

    }

  }
}
</script>

<style scoped>

.indice {
  padding-top: 4px; 
  font-size: 16px;
  font-style: italic;
  color: #404040;
  font-weight: normal;
}

table, th, td {
  border: 1px solid black !important;
  margin: 10px;
  padding: 5px;
  border-collapse: collapse;
}

th {
  background-color: cadetblue !important;
  color: white !important;
  text-align: center !important;
}

.couvert {
  background-color: #90CAF9;
}

.ouvert {
  background-color: #FFF59D;
}

.fermeok {
  background-color: #A5D6A7;
}

.annule {
  background-color: red;
  color: white;
}
</style>